<template>
    <div>
      <div class="rownew" style="width:50%">
        <div class="search" >
          <input
            type="text"
            class="search-input"
            id="search-input"
            :placeholder="placeholder"
            @input="setSearchStr"
            @keyup.enter="sendsearchReq"
          />
          <span class="search-icone-wrap right">
            <img v-if="!loading" src="../../../images/dashboard/refresh.png" alt="#" @click="clear"/>
            <img v-else class="loading-gif" src="../../../images/dashboard/reloading-gif.svg" alt="Refresh" />
          </span>
          <span class="search-icone-wrap left">
            <img src="../../../images/header/search_icone.svg" alt="#" />
          </span>
        </div>
      </div>
      <!-- <div class="filter-wrap-custom">
        <button
            class="btn btn-test"
            @click="addInventory"
            @click.stop="stopPropagation"
          >
                Add Inventory
        </button>
      </div> -->
      <!-- <div class="filter-wrap-custom">
     
            <select id="locationSelect" class="input-filter" v-model="selectedLocation" @change="handleLocationChange">
              <option disabled value="">Select a region</option>
              <option v-for="location in locations" :key="location.id" :value="location.id">
                {{ location.location }}
              </option>
            </select>
      </div> -->
      <!-- <div class="filter-wrap-custom">
            <select id="itemSelect"  class="input-filter" v-model="selectedItem" @change="handleItemChange">
              <option disabled value="">Select an item</option>
              <option v-for="item in items" :key="item.id" :value="item.id">
                {{ item.item_name }}
              </option>
            </select>
        </div> -->
    </div>
  </template>
   
  <script>
  import { mapActions } from "vuex";
   
  export default {
    name: "InventorySearch",
    data() {
      return {
        inputWidth: false,
        showMenu: false,
        loading:false,
        placeholder: 'Search',
        item: 0,
        selectedLocation: '',
        locations:[],
        selectedItem: '', // Default value to show the placeholder
        items: []
      };
    },
    methods: {
      ...mapActions([
        "setInvSearchString",
        "setInventory",
        "setPage",
        "setFillocation",
        "setFilItem"
      ]),
      stopPropagation(event) {
        event.stopPropagation();
      },
      addInventory(){
          this.$emit("showAddInv", true);
      },
      setSearchStr(e) {
        this.setPage(1);
        this.setInvSearchString(e.target.value);
      },
      async sendsearchReq() {
        this.loading = true;
        this.setPage(1);
        await  this.setInventory(); 
        this.loading = false;
      },
      handleLocationChange(){
        this.loading = true;
        this.setPage(1);
        this.setFillocation(this.selectedLocation).then(async res => {
          // await this.setInventory();
        })
        this.loading = false;
      },
      handleItemChange(){
        this.loading = true;
        this.setPage(1);
        this.setFilItem(this.selectedItem).then(async res => {
          await  this.setInventory(); 
        })
        this.loading = false;
      },
      async  clear(){
        document.getElementById("search-input").value = "";
        this.setInvSearchString(null);
        await  this.setInventory();
      }
    },
    mounted(){
        this.locations = this.$store.getters.getLocation;
        this.items = this.$store.getters.getItem;
    }
  };
  </script>
   
  <style scoped>
    .rownew {
      display: flex;
      width: 100%;
    }
    .search {
      max-width: 412px;
      width: 100%;
      position: absolute;
      background-color: #eee;
      border: 1px solid #eee;
      left: 0%;
      top: 0%;
      border-radius: 25px;
      transform: translate(0%, 0%);
    }
    .search-input {
      font-size: 14px;
      font-weight: 500px;
      font-family: TTNormsMedium, sans-serif;
      width: 100%;
      padding: 10px 50px;
      border: none;
      background-color: #fff;
      outline: none;
      border-radius: 5px;
      transition: all 0.5s linear;
    }
    .search-input::placeholder {
      color: #757575;
      font-family: TTNormsLight, sans-serif;
      opacity: 0.8;
    }
    .search-input:focus {
      background-color: #e3e3e3;
    }
    .search-icone-wrap {
      position: absolute;
      width: 20px;
    }
    .search-icone-wrap.right {
      right: 10px;
      top: 8px;
    }
    .search-icone-wrap.left {
      left: 30px;
      top: 10px;
    }
    .search-icone-wrap.left img {
      max-width: 70%;
      height: auto;
    }
    .search-icone-wrap.right img {
      max-width: 100%;
    }
    .loading-gif {
    width: 26px;
    height: 23.3833px;
    }
    .filter-wrap-custom {
     display: inline-flex;
     margin-left : 10px;
    }
    .input-filter {
        padding: 5px 10px;
        color: #373737;
        width: 100%;
        font-size: 16px;
        text-align: center;
        outline: none;
        border-radius: 10px;
        border: 1px solid #cccccc;
        font-family: TTNormsLight, sans-serif;
        background: white;
    }
    .btn {
      display: flex;
      align-items: center;
      justify-content: center;
      outline: none;
      border: 1px solid transparent;
      font-size: 12px;
      font-family: TTNormsLight, sans-serif;
      padding: 6px 15px 6px 15px;
      height: 30px;
      margin: 0 0 0 13px;
      cursor: pointer;
      border-radius: 5px;
    }
    .btn-test {
      background-color: #005eb8;
      color: #fff;
      max-width: 128px;
      width: 100%;
    }
  </style>
   